import { useEffect, useRef } from "react";

const SW = 192, SH = 108, W = 256, H = 128;

function graticule(ctx) {
  ctx.strokeStyle = "rgba(255,255,255,0.12)";
  ctx.fillStyle = "rgba(255,255,255,0.35)";
  ctx.font = "8px JetBrains Mono, monospace";
  [0, 25, 50, 75, 100].forEach((v) => {
    const y = Math.round(H - 1 - (v / 100) * (H - 1)) + 0.5;
    ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(W, y); ctx.stroke();
    ctx.fillText(String(v), 2, Math.max(8, y - 2));
  });
}

function paint(canvas, layers) {
  const ctx = canvas.getContext("2d");
  const img = ctx.createImageData(W, H);
  for (let i = 0; i < W * H; i++) {
    let r = 0, g = 0, b = 0;
    layers.forEach(([acc, col]) => {
      const v = Math.pow(Math.min(1, acc[i] * 0.22), 0.6);
      r += v * col[0]; g += v * col[1]; b += v * col[2];
    });
    img.data[i * 4] = Math.min(255, r); img.data[i * 4 + 1] = Math.min(255, g); img.data[i * 4 + 2] = Math.min(255, b); img.data[i * 4 + 3] = 255;
  }
  ctx.putImageData(img, 0, 0);
  graticule(ctx);
}

function analyse(d, wave, parade) {
  const luma = new Float32Array(W * H), ch = [new Float32Array(W * H), new Float32Array(W * H), new Float32Array(W * H)];
  const band = Math.floor(W / 3);
  for (let y = 0; y < SH; y++)
    for (let x = 0; x < SW; x++) {
      const p = (y * SW + x) * 4;
      const l = 0.2126 * d[p] + 0.7152 * d[p + 1] + 0.0722 * d[p + 2];
      luma[(H - 1 - Math.floor((l / 255) * (H - 1))) * W + Math.floor((x / SW) * W)]++;
      const bx = Math.floor((x / SW) * band);
      for (let k = 0; k < 3; k++) ch[k][(H - 1 - Math.floor((d[p + k] / 255) * (H - 1))) * W + k * band + bx]++;
    }
  paint(wave, [[luma, [170, 255, 200]]]);
  paint(parade, [[ch[0], [255, 70, 70]], [ch[1], [70, 255, 110]], [ch[2], [80, 140, 255]]]);
}

export const Scopes = ({ canvasRef }) => {
  const wave = useRef(null), parade = useRef(null);
  useEffect(() => {
    const tmp = document.createElement("canvas");
    tmp.width = SW; tmp.height = SH;
    const tctx = tmp.getContext("2d", { willReadFrequently: true });
    const id = setInterval(() => {
      const src = canvasRef.current;
      if (!src || !src.width || !wave.current) return;
      tctx.drawImage(src, 0, 0, SW, SH);
      analyse(tctx.getImageData(0, 0, SW, SH).data, wave.current, parade.current);
    }, 120);
    return () => clearInterval(id);
  }, [canvasRef]);

  return (
    <div className="w-60 xl:w-72 shrink-0 flex flex-col gap-2 overflow-y-auto" data-testid="scopes-panel">
      {[["Waveform · luma", wave, "scope-waveform"], ["RGB parade", parade, "scope-parade"]].map(([label, ref, tid]) => (
        <div key={tid} className="bg-black/70 border border-[#2A2E3D] rounded-md p-2">
          <p className="text-[10px] uppercase font-mono-ui tracking-wider text-slate-400 mb-1.5">{label}</p>
          <canvas ref={ref} width={W} height={H} className="w-full block rounded-sm" style={{ imageRendering: "pixelated" }} data-testid={tid} />
        </div>
      ))}
      <p className="text-[10px] text-slate-500 px-1 leading-relaxed">0 = black, 100 = peak white. Keep skin in the 55–75 band; clipped highlights stack at 100.</p>
    </div>
  );
};
